/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Vote choices */
export enum VoteChoice {
  For,
  Against,
  Abstain,
}

export type VoteChoiceArgs = VoteChoice;

export function getVoteChoiceEncoder(): FixedSizeEncoder<VoteChoiceArgs> {
  return getEnumEncoder(VoteChoice);
}

export function getVoteChoiceDecoder(): FixedSizeDecoder<VoteChoice> {
  return getEnumDecoder(VoteChoice);
}

export function getVoteChoiceCodec(): FixedSizeCodec<
  VoteChoiceArgs,
  VoteChoice
> {
  return combineCodec(getVoteChoiceEncoder(), getVoteChoiceDecoder());
}
